// import React, { useEffect, useState } from 'react'
// import axios from 'axios'
// import ReactPaginate from 'react-paginate'
// import Swal from 'sweetalert2'
// import admindata from '../../components/admindata'
// import Loader from 'react-js-loader'
// import $ from 'jquery';
// import 'datatables.net-dt/css/jquery.dataTables.css';
// import 'datatables.net';
// import Modal from "react-bootstrap/Modal";
// import Spinner from 'react-bootstrap/Spinner';
// import { FaArrowUp } from "react-icons/fa";
// import Compressor from "compressorjs";
// import "../../dashboard/Dashboard.css"
// import { apiRequest } from '../../apiServices/allApi'


// export default function AgentWallet() {
//   const [data, setUser] = useState()
//   const permission1 = localStorage.getItem("PData");
//   const pdata = JSON.parse(permission1);
//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
//   const nodeMode = process.env.NODE_ENV
//   const baseUrl = nodeMode === 'development' ? beckendLocalApiUrl : beckendLiveApiUrl
//   const [loading, setLoading] = useState(false)
//   const [show_won, setShow_won] = useState(false);
//   const [global, setGlobal] = useState(100);
//   const [id, setid] = useState('');
// const [amountType, setAmountType] = useState("add")

//   const handleClose_won = () => setShow_won(false);
//   const [scrnshot, setScrnshot] = useState(null);
//   const [fecthStatus, setFecthStatus] = useState();
//   const [scrnshot1, setScrnshot1] = useState("");
//   const [reason, setreason] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);



//   // Pagination state
//   const [limit, setLimit] = useState(30)
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)

//   // Search state
//   const [searchList, setSearchList] = useState(0)
//   const [searchType, setSearchType] = useState("Phone")
//     const meedata = localStorage.getItem("uData");
//   const userData = JSON.parse(meedata);

//   // Input states
//   const [bonus, setBonus] = useState()
//   const [type, setType] = useState("wallet") // Default type is "wallet"

//   const handlePageClick = async (data) => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//   }

//   const setpageLimit = (event) => {
//     setLimit(event.target.value)
//   }

//   const searchHandler = (event) => {
//     setSearchList(event.target.value)
//   }

//   const handleChange = (e) => {
//     setScrnshot1(URL.createObjectURL(e.target.files[0]));
//     const image = e.target.files[0];
//     if (image && image.size / 1000 > 300) {
//       console.log(" compression");
//       new Compressor(image, {
//         quality: 0.6,
//         success(compressedResult) {
//           if (compressedResult) {
//             setScrnshot(compressedResult);
//           } else {
//             setScrnshot(image);
//           }
//         },
//       });
//     } else {
//       setScrnshot(e.target.files[0]);
//     }
//   };
//    // clear Image
//    const clearImage = (e) => {
//     setScrnshot1(null);
//     setScrnshot(null);
//   };

// const handleShow_won = (amount,id,type) => {
//   setShow_won(true)
//   setGlobal(amount)
//   setid(id)
//   setAmountType(type)
// }


//   const Alluser =async () => {
//     setLoading(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
   
//      try {
//           const res = await apiRequest(`agent/Security_Deposit?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}`,"GET", null,headers)
//          if (res.data) {
//                setLoading(false)
//         setUser(res.data.admin)
//         setNumberOfPages(res.data.totalPages)
//          }
//             } catch (e) {
//               setLoading(false);
//             }
//             finally {
//             }
//   }

//   const update = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }

//     var pathUrl = amountType === "add" ? "Security_Deposit/plus" : "Security_Deposit/minus"

//     var formdata = new FormData();
//     formdata.append("amount", JSON.parse(global));
//     formdata.append("reason", reason);
//     formdata.append("id", id);
//     if (amountType === "add") {
//       formdata.append("paymentImage", scrnshot);
//     }
   
//        try {
//             const res = await apiRequest(`${pathUrl}`,"POST", formdata,headers)
//            if (res.data) {
//                 Alluser()
//           handleClose_won()
//            }
//               } catch (e) {
//                 setLoading(false);
//               }
//               finally {
//               }
   
//   }

//   useEffect(() => {
//     Alluser()
//   }, [pageNumber, limit, searchList, searchType])

//   return (
//     <>
//       <div className='row mt-5'>
//         <div className='col-12 grid-margin'>
//           <div className='card'>
//             <div className='card-body text-light table_bg'>
//               <h4 className='dashboard_heading'>Agent Wallet</h4>
//               {/* Searching */}
//               <div className='row'>
//                 <select
//                   className='form-control col-sm-3 m-2'
//                   id='searchType'
//                   name='searchtype'
//                   onChange={(e) => setSearchType(e.target.value)}
//                 >
//                   <option value='0'>Select Search by</option>
//                   <option value='Name'>Name</option>
//                   <option value='Phone'>Phone</option>
//                   <option value='_id'>User Id</option>
//                 </select>
//                 <input
//                   type='text'
//                   placeholder='Search...'
//                   className='form-control col-sm-4 m-2'
//                   onChange={searchHandler}
//                 />
//                 <select
//                   className='form-control col-sm-1 m-1 bg-dark text-light'
//                   id='pagelimit'
//                   name='pagelimit'
//                   onChange={setpageLimit}
//                 >
//                   <option value='30'>Set limit</option>
//                   <option value='40'>40</option>
//                   <option value='50'>50</option>
//                   <option value='100'>100</option>
//                   <option value='500'>500</option>
//                 </select>
//               </div>
//               <div className='table-responsive'>
//                 <table className='table text-light'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>ID</th>
//                       <th>Name</th>
//                       <th>Type</th>
//                       <th>Mobile</th>
//                       <th>Balance</th>
//                       <th>Total Add</th>
//                       <th>Total Penalty</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                  <tbody>
//   {data &&
//     data?.map((data, key) =>
//       (userData?.id == data._id || userData?.user_type === "Admin") ? (
//         <tr key={key} role="row" className="odd">
//           <td>{key + 1}</td>
//           <td>{data._id}</td>
//           <td>{data.Name}</td>
//           <td>{data.user_type}</td>
//           <td className="text-success">{data.Phone}</td>
//           <td>{data.Wallet_balance}</td>
//           <td>{data.totalDeposit}</td>
//           <td>{data.totalPenalty}</td>
//           <td>
//             <div className="row">
//               <div className="col-12 col-lg-3">
//                 <button
//                   className="btn btn-sm btn-primary mr-2"
//                   onClick={() =>
//                     handleShow_won(data.Wallet_balance, data._id, "add")
//                   }
//                 >
//                   Add Amount
//                 </button>

//                 {userData.user_type === "Admin" ? (
//                   <button
//                     className="btn btn-sm btn-primary"
//                     onClick={() =>
//                       handleShow_won(data.Wallet_balance, data._id, "penalty")
//                     }
//                   >
//                     Penalty
//                   </button>
//                 ) : (
//                   ""
//                 )}
//               </div>
//             </div>
//           </td>
//         </tr>
//       ) : null
//     )}
// </tbody>

//                 </table>
//               </div>
//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//         <section className="win_modal">
//         <Modal
//           show={show_won}
//           onHide={handleClose_won}
//           className="cancel_popup_reason_popup"
//           aria-labelledby="contained-modal-title-vcenter"
//           centered
//         >
//           <Modal.Header closeButton></Modal.Header>
//           <Modal.Body>
//             <div>
//               <h3>Payment Details</h3>
//               <div>
//                 <lable className="commaon_label">AMOUNT</lable>
//                 <input
//                   className="commaon_input_box mb-2"
//                   type="number"
//                   required
//                   onChange={(e) => setGlobal(e.target.value)}
//                   placeholder="Enter amount"
//                 />
//                 <lable className="commaon_label mt-4">Enter Reason</lable>
//                 <input
//                   className="commaon_input_box"
//                   type="text"
//                   required
//                   value={reason}
//                   onChange={(e) => setreason(e.target.value)}
//                   placeholder="Enter Reason"
//                 />
//               </div>
// {
//   amountType == "add" ?
// <>

//               <div className={` mt-4 upload_ss_btn`}>
//                 <input
//                   type="file"
//                   onChange={handleChange}
//                   accept="image/*"
//                   required
//                 />
//                 {!scrnshot && (
//                   <div className="cxy flex-column position-absolute ">
//                    <FaArrowUp style={{color:"#fff"}}/>
//                     <div
//                       className={` mt-2 upload_ss_btn_name`}
//                     >
//                       Upload screenshot.
//                     </div>
//                   </div>
//                 )}
                
//               </div>

//               <div style={{ width: "100%", marginTop: "20px" }}>
//                 <img
//                   src={scrnshot1}
//                   style={{ width: "100%" }}
//                   className="screenshot_img"
//                   required
//                 />
//               </div>
//               </>
//               :""}

//               {/* {fecthStatus == null && fecthStatus == undefined && (
//                 <input
//                   type="submit"
//                   value="S
//                   ubmit"
//                   className="btn btn-danger mt-3 text-white results_btn w-100"
//                   id="post"
//                   // onClick={(e) => {
//                   //   Result(e);
//                   // }}
//                   onClick={ManualPayments}
//                   disabled={!scrnshot}
//                 />
//               )} */}

//               {fecthStatus == null && fecthStatus == undefined && (
//                 <>
//                   {isLoading1 ? (
//                     <button className="Login-button cxy" disabled>
//                       <Spinner
//                         as="span"
//                         animation="grow"
//                         size="sm"
//                         role="status"
//                         aria-hidden="true"
//                       />
//                       Loading...
//                     </button>
//                   ) : (
//                     <input
//                       type="submit"
//                       value="SUBMIT"
//                       className="btn btn-danger mt-3 text-white results_btn w-100"
//                       id="post"
//                       onClick={update}
//                       disabled={!reason}
//                       style={{ fontSize: "20px !important" }}
//                     />
//                   )}
//                 </>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//       </section>
//       </div>
//     </>
//   )
// }


import React, { useEffect, useState } from 'react'
import axios from 'axios'
import ReactPaginate from 'react-paginate'
import Swal from 'sweetalert2'
import admindata from '../../components/admindata'
import Loader from 'react-js-loader'
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import Modal from "react-bootstrap/Modal";
import Spinner from 'react-bootstrap/Spinner';
import { FaArrowUp } from "react-icons/fa";
import Compressor from "compressorjs";
import { apiRequest } from '../../apiServices/allApi'
// import './AgentWallet.css'

export default function AgentWallet() {
  const [data, setUser] = useState()
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  const baseUrl = nodeMode === 'development' ? beckendLocalApiUrl : beckendLiveApiUrl
  const [loading, setLoading] = useState(false)
  const [show_won, setShow_won] = useState(false);
  const [global, setGlobal] = useState(100);
  const [id, setid] = useState('');
  const [amountType, setAmountType] = useState("add")

  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [fecthStatus, setFecthStatus] = useState();
  const [scrnshot1, setScrnshot1] = useState("");
  const [reason, setreason] = useState("");
  const [isLoading1, setIsloading1] = useState(false);

  // Pagination state
  const [limit, setLimit] = useState(30)
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  // Search state
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);

  // Input states
  const [bonus, setBonus] = useState()
  const [type, setType] = useState("wallet")

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const setpageLimit = (event) => {
    setLimit(event.target.value)
  }

  const searchHandler = (event) => {
    setSearchList(event.target.value)
  }

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      console.log(" compression");
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
  };

  const handleShow_won = (amount, id, type) => {
    setShow_won(true)
    setGlobal(amount)
    setid(id)
    setAmountType(type)
  }

  const Alluser = async () => {
    setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`agent/Security_Deposit?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}`, "GET", null, headers)
      if (res.data) {
        setLoading(false)
        setUser(res.data.admin)
        setNumberOfPages(res.data.totalPages)
      }
    } catch (e) {
      setLoading(false);
    }
  }

  const update = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    var pathUrl = amountType === "add" ? "Security_Deposit/plus" : "Security_Deposit/minus"

    var formdata = new FormData();
    formdata.append("amount", JSON.parse(global));
    formdata.append("reason", reason);
    formdata.append("id", id);
    if (amountType === "add") {
      formdata.append("paymentImage", scrnshot);
    }

    try {
      const res = await apiRequest(`${pathUrl}`, "POST", formdata, headers)
      if (res.data) {
        Alluser()
        handleClose_won()
      }
    } catch (e) {
      setLoading(false);
    }
  }

  useEffect(() => {
    Alluser()
  }, [pageNumber, limit, searchList, searchType])

  return (
    <div className='agentwallet-page-container'>
      <div className='agentwallet-main-card'>
        <h4 className='agentwallet-heading-main'>Agent Wallet Management</h4>

        {/* Filter Bar Controls */}
        <div className='agentwallet-filter-bar'>
          <select
            className='custom-agentwallet-input'
            id='searchType'
            name='searchtype'
            onChange={(e) => setSearchType(e.target.value)}
          >
            <option value='0'>Select Search by</option>
            <option value='Name'>Name</option>
            <option value='Phone'>Phone</option>
            <option value='_id'>User Id</option>
          </select>

          <input
            type='text'
            placeholder='Search Keyword...'
            className='custom-agentwallet-input'
            onChange={searchHandler}
          />

          <select
            className='custom-agentwallet-input'
            id='pagelimit'
            name='pagelimit'
            onChange={setpageLimit}
          >
            <option value='30'>Limit: 30</option>
            <option value='40'>Limit: 40</option>
            <option value='50'>Limit: 50</option>
            <option value='100'>Limit: 100</option>
            <option value='500'>Limit: 500</option>
          </select>
        </div>

        {/* Responsive Table Content */}
        <div className='table-responsive-wrapper'>
          <table className='agentwallet-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Name</th>
                <th>Type</th>
                <th>Mobile</th>
                <th>Balance</th>
                <th>Total Add</th>
                <th>Total Penalty</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data?.map((dataItem, key) =>
                  (userData?.id == dataItem._id || userData?.user_type === "Admin") ? (
                    <tr key={key} role="row" className="odd">
                      <td>{key + 1}</td>
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{dataItem._id}</td>
                      <td>
                        <span className='agent-name-text'>{dataItem.Name}</span>
                      </td>
                      <td style={{ color: '#cbd5e1' }}>{dataItem.user_type}</td>
                      <td style={{ color: '#34d399', fontWeight: 600 }}>{dataItem.Phone}</td>
                      <td>
                        <span className='wallet-amount-green'>₹{dataItem.Wallet_balance}</span>
                      </td>
                      <td style={{ fontWeight: 600 }}>₹{dataItem.totalDeposit}</td>
                      <td>
                        <span className='penalty-amount-red'>₹{dataItem.totalPenalty}</span>
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            className="btn-wallet-add"
                            onClick={() =>
                              handleShow_won(dataItem.Wallet_balance, dataItem._id, "add")
                            }
                          >
                            Add Amount
                          </button>

                          {userData.user_type === "Admin" && (
                            <button
                              className="btn-wallet-penalty"
                              onClick={() =>
                                handleShow_won(dataItem.Wallet_balance, dataItem._id, "penalty")
                              }
                            >
                              Penalty
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ) : null
                )}
            </tbody>
          </table>
        </div>

        {/* Pagination Container */}
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-content-center'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>

        {/* Payment Modal */}
        <Modal
          show={show_won}
          onHide={handleClose_won}
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-body-custom">
            <div>
              <h3 className="modal-title-text">Payment Details</h3>
              <div className="mb-3">
                <label className="form-label-custom">Amount</label>
                <input
                  className="form-input-modal"
                  type="number"
                  required
                  onChange={(e) => setGlobal(e.target.value)}
                  placeholder="Enter amount"
                />
              </div>

              <div className="mb-3">
                <label className="form-label-custom">Enter Reason</label>
                <input
                  className="form-input-modal"
                  type="text"
                  required
                  value={reason}
                  onChange={(e) => setreason(e.target.value)}
                  placeholder="Enter Reason"
                />
              </div>

              {amountType === "add" && (
                <>
                  <div className="dropzone-upload-box">
                    <input
                      type="file"
                      onChange={handleChange}
                      accept="image/*"
                      required
                    />
                    {!scrnshot && (
                      <div>
                        <FaArrowUp style={{ color: "#38bdf8", fontSize: '1.5rem' }} />
                        <div style={{ color: "#94a3b8", fontSize: "0.85rem", fontWeight: 600, marginTop: "6px" }}>
                          Upload payment screenshot
                        </div>
                      </div>
                    )}
                  </div>

                  {scrnshot1 && (
                    <div style={{ width: "100%", marginTop: "15px" }}>
                      <img
                        src={scrnshot1}
                        alt="Screenshot Preview"
                        style={{ width: "100%", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.1)" }}
                      />
                    </div>
                  )}
                </>
              )}

              {fecthStatus == null && fecthStatus === undefined && (
                <>
                  {isLoading1 ? (
                    <button className="btn-modal-submit" disabled>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Processing...
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn-modal-submit"
                      onClick={update}
                      disabled={!reason}
                    >
                      Submit
                    </button>
                  )}
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>

      </div>
    </div>
  )
}